import { render, staticRenderFns } from "./user-other-address-modal.vue?vue&type=template&id=6e1c32e2&scoped=true&"
import script from "./user-other-address-modal.vue?vue&type=script&lang=js&"
export * from "./user-other-address-modal.vue?vue&type=script&lang=js&"
import style0 from "./user-other-address-modal.vue?vue&type=style&index=0&id=6e1c32e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1c32e2",
  null
  
)

export default component.exports